module.exports = __webpack_public_path__ + "static/media/link.ca62d463.png";